import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FiMenu } from "react-icons/fi";

import "./FullMenu.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import WhatsAppButton from "./WhatsAppButton";
import { Footer } from "./Footer";

const FullMenu = ({ lightMode = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1000);

  const [submenuOpen, setSubmenuOpen] = useState({}); // All categories closed by default

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1000);
    };

    // Listen for custom closeMenus event from FloatingKontaktButton
    const handleCloseMenus = () => {
      setIsOpen(false);
      setSubmenuOpen({});
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("closeMenus", handleCloseMenus);

    // Cleanup function
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("closeMenus", handleCloseMenus);
    };
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("no-scroll");
      document.body.classList.add("full-menu-open");
    } else {
      document.body.classList.remove("no-scroll");
      document.body.classList.remove("full-menu-open");
    }

    return () => {
      document.body.classList.remove("no-scroll");
      document.body.classList.remove("full-menu-open");
    };
  }, [isOpen]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    // Reset all categories to closed when opening the menu
    if (!isOpen) {
      setSubmenuOpen({});
    }
  };

  const toggleSubmenu = (name) => {
    setSubmenuOpen((prev) => ({
      [name]: !prev[name],
    }));
  };

  // Temporarily hide FullMenu to test MobileMenu on desktop
  return null;
  return (
    <>
      <div className={`mobile-menu ${isOpen ? "open" : ""}`}>
        {!isMobile && (
          <div className="full-menu-icon" onClick={toggleMenu}>
            <div
              className={`luxury-hamburger ${isOpen ? "open" : ""}`}
              style={{ color: lightMode ? "var(--color-primary)" : "white" }}
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        )}
        <div className="full-menu-links-container">
          <div className="full-menu-links full-height">
            <div className="full-menu-links-inner">
              <Link to="/" onClick={toggleMenu} className="full-menu-item">
                <span>Die Werkstatt</span>
              </Link>
              {/* Example menu item with submenu */}

              {/* MOTORENBAU */}
              <div
                className="full-menu-item full-menu-item-active"
                onClick={() => toggleSubmenu("motorenbau")}
              >
                <span
                  className={` ${
                    submenuOpen["motorenbau"] ? "submenu-open" : ""
                  }`}
                >
                  Motorenbau
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    className={`full-submenu-arrow ${
                      submenuOpen["motorenbau"] ? "open" : ""
                    }`}
                  />
                </span>
              </div>

              {/* RESTAURATION & UMBAU */}
              <div
                className="full-menu-item"
                onClick={() => toggleSubmenu("restauration")}
              >
                <span
                  className={` ${
                    submenuOpen["restauration"] ? "submenu-open" : ""
                  }`}
                >
                  Restauration & Umbau
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    className={`full-submenu-arrow ${
                      submenuOpen["restauration"] ? "open" : ""
                    }`}
                  />
                </span>
              </div>

              {/* SERVICE & WARTUNG  */}
              <div
                className="full-menu-item"
                onClick={() => toggleSubmenu("service")}
              >
                <span
                  className={` ${submenuOpen["service"] ? "submenu-open" : ""}`}
                >
                  Service & Wartung
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    className={`full-submenu-arrow ${
                      submenuOpen["service"] ? "open" : ""
                    }`}
                  />
                </span>
              </div>

              {/* ANKAUF & VERKAUF */}
              <div
                className="full-menu-item"
                onClick={() => toggleSubmenu("sales")}
              >
                <span
                  className={` ${submenuOpen["sales"] ? "submenu-open" : ""}`}
                >
                  Ankauf & Verkauf
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    className={`full-submenu-arrow ${
                      submenuOpen["sales"] ? "open" : ""
                    }`}
                  />
                </span>
              </div>

              <Link
                to="/kontakt"
                onClick={toggleMenu}
                className="full-menu-item"
              >
                <span>Kontakt</span>
              </Link>
            </div>
            <div class="submenu-links">
              <div
                className={`full-submenu ${
                  submenuOpen["motorenbau"] ? "open" : ""
                }`}
              >
                <Link
                  to="/motorenbau/leistungssteigerungen"
                  onClick={toggleMenu}
                >
                  <span>Motorenbau & Leistungssteigerungen</span>
                </Link>
                <Link
                  to="/motorenbau/motor-revision-356-911-964-993"
                  onClick={toggleMenu}
                >
                  <span class="full-menu-item-flex">
                    <div>Motor-Revision</div> <div> 911 / 964 / 993</div>
                  </span>
                </Link>
                <Link
                  to="/motorenbau/motor-instandsetzung-996-997-991-992"
                  onClick={toggleMenu}
                >
                  <span class="full-menu-item-flex">
                    <div>Motor-Instandsetzung</div> <div> 996 / 997 / 991</div>
                  </span>
                </Link>
                <Link
                  to="/motorenbau/getriebe-revision-911-964-993"
                  onClick={toggleMenu}
                >
                  <span class="full-menu-item-flex">
                    <div>Getriebe-Revision</div> <div> 911 / 964 / 993</div>
                  </span>
                </Link>
              </div>

              <div
                className={`full-submenu ${
                  submenuOpen["restauration"] ? "open" : ""
                }`}
              >
                <Link to="/restauration" onClick={toggleMenu}>
                  <span>Porsche Restauration</span>
                </Link>
                <Link
                  to="/motorenbau/leistungssteigerungen"
                  onClick={toggleMenu}
                >
                  <span>Porsche Leistungssteigerungen</span>
                </Link>
                {/* <Link to="/#engine-restoration" onClick={toggleMenu}>
                  <span>Porsche Fahrwerk</span>
                </Link>
                <Link to="/#engine-restoration" onClick={toggleMenu}>
                  <span>Porsche Bremsen</span>
                </Link>
                <Link to="/#engine-restoration" onClick={toggleMenu}>
                  <span>Porsche Auspuffanlagen</span>
                </Link>
                <Link to="/#engine-restoration" onClick={toggleMenu}>
                  <span>Porsche Karosserieumbau</span>
                </Link> */}
                <Link to="/motorsport" onClick={toggleMenu}>
                  <span>Porsche Motorsport</span>
                </Link>
              </div>

              <div
                className={`full-submenu ${
                  submenuOpen["service"] ? "open" : ""
                }`}
              >
                <Link to="/service-wartung" onClick={toggleMenu}>
                  <span>Inspektion & Wartung</span>
                </Link>
                <Link to="/porsche-elektronik" onClick={toggleMenu}>
                  <span>Porsche Elektronik</span>
                </Link>
                <Link to="/porsche-reparatur" onClick={toggleMenu}>
                  <span>Porsche Reparatur</span>
                </Link>
                <Link to="/porsche-gutachten" onClick={toggleMenu}>
                  <span>TÜV-Eintragung & Gutachten</span>
                </Link>
                {/* <Link to="/#engine-restoration" onClick={toggleMenu}>
                  <span>Unfallinstandsetzung</span>
                </Link> */}
              </div>

              <div
                className={`full-submenu ${submenuOpen["sales"] ? "open" : ""}`}
              >
                <Link to="/aktuelle-angebote" onClick={toggleMenu}>
                  <span>Aktuelle Angebote</span>
                </Link>
                <Link to="/porsche-verkaufen" onClick={toggleMenu}>
                  <span>Porsche verkaufen</span>
                </Link>
              </div>
            </div>

            {/* <Footer /> */}
          </div>
        </div>
      </div>
      <div className={`milk-glass ${isOpen ? "milk-glass-open" : ""}`}></div>
    </>
  );
};

export default FullMenu;
